import { Box } from '@mui/material';
import { AssetListViewOptions, ListCell } from '/src/components';
import { ListDataItem } from '/src/lib/types';

export type ListRowProps = {
  /**
   * List data items
   */
  items: ListDataItem[];
  /**
   * This row's index in the list
   */
  rowIndex: number;
  /**
   * Data row height. Defaults to 48px
   */
  rowHeight?: number;
  /**
   * Whether to adjust padding to account for a scrollbar. Used for longer lists
   */
  padForScrollbar?: boolean;
  /**
   * Bolds the data row value
   */
  bold?: boolean;
  /**
   * Shows/hides data items
   */
  viewOptions?: AssetListViewOptions;
};

export const ListRow = ({ items, rowIndex, rowHeight = 48, padForScrollbar, bold, viewOptions }: ListRowProps) => {
  /** Render **/
  return (
    <Box
      paddingX="16px"
      display="flex"
      alignItems="center"
      className={`text-center ${bold ? 'medium' : ''} md-subhead-sm ${rowIndex % 2 ? '' : 'highlighted'}  ${
        padForScrollbar ? 'padForScrollbar' : ''
      }`}
      sx={{ height: rowHeight + 'px' }}
    >
      {items
        .filter((item) => (!item.hide || item.isNotes) && (viewOptions ? viewOptions[item.propName] : true))
        .map(({ propName, ...itemProps }, i) => (
          <ListCell className={bold ? 'medium' : ''} key={`${propName}-${i}`} {...itemProps} />
        ))}
    </Box>
  );
};
